import React from "react";

const SvgBBiconsEssHodnoceni = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <defs>
      <style>{".BBicons_ESS_hodnoceni_svg__cls-1{fill-rule:evenodd}"}</style>
    </defs>
    <g
      id="BBicons_ESS_hodnoceni_svg__Obecn\xE9_ikony"
      data-name="Obecn\xE9 ikony"
    >
      <path
        className="BBicons_ESS_hodnoceni_svg__cls-1"
        d="M67 101.56H50.48a3.41 3.41 0 01-3.41-3.42v-.09a3.4 3.4 0 013.41-3.41H67v-17H50.48a3.43 3.43 0 01-3.41-3.44v-.06a3.41 3.41 0 013.41-3.42H67V69.2a8.25 8.25 0 018.22-8.39h32V37a4.07 4.07 0 00-4-4.23H43.74a4.07 4.07 0 00-4 4.23v123.22h-6.96a3.53 3.53 0 100 7.06H59.6a7.29 7.29 0 011.47-7.78v-25.28a2.2 2.2 0 012.12-2.3H67zM47.07 50.22a3.4 3.4 0 013.41-3.41h46a3.43 3.43 0 013.44 3.41v.09a3.43 3.43 0 01-3.44 3.41h-46a3.4 3.4 0 01-3.41-3.41z"
      />
      <path
        className="BBicons_ESS_hodnoceni_svg__cls-1"
        d="M168.08 162h-5.36a4.21 4.21 0 00.16-.83V101a3.39 3.39 0 00-3.23-3.58H128.6a3.37 3.37 0 00-3.2 3.58v60.15a3.59 3.59 0 00.15.83h-2.64V69.2a3.08 3.08 0 00-3-3.2H75.17a3.08 3.08 0 00-3 3.2V162h-5.26a2.66 2.66 0 100 5.31h101.17a2.66 2.66 0 100-5.31zm-61.23-.35H88.2v-19.26a1.64 1.64 0 011.6-1.71h15.45a1.64 1.64 0 011.6 1.71zm10.55-46.38a2.57 2.57 0 01-2.57 2.57H80.24a2.57 2.57 0 01-2.57-2.57v-.06a2.57 2.57 0 012.57-2.58h34.59a2.57 2.57 0 012.57 2.58zm0-18a2.59 2.59 0 01-2.57 2.6H80.24a2.59 2.59 0 01-2.57-2.6 2.57 2.57 0 012.57-2.57h34.59a2.57 2.57 0 012.57 2.57zm0-18a2.57 2.57 0 01-2.57 2.57H80.24a2.57 2.57 0 01-2.57-2.57v-.06a2.57 2.57 0 012.57-2.58h34.59a2.57 2.57 0 012.57 2.58zM155.07 154h-21.76a2.61 2.61 0 110-5.21h21.76a2.61 2.61 0 110 5.21zm0-13.85h-21.76a2.64 2.64 0 01-2.64-2.63 2.59 2.59 0 012.64-2.58h21.76a2.62 2.62 0 012.66 2.58 2.65 2.65 0 01-2.66 2.58zm0-13.89h-21.76a2.6 2.6 0 110-5.2h21.76a2.6 2.6 0 110 5.2zm0-13.87h-21.76a2.6 2.6 0 110-5.19h21.76a2.6 2.6 0 110 5.19zM135.76 71.16l12.5-6.62 12.49 6.62-2.44-13.93 10.16-9.83-14-1.98-6.21-12.7-6.22 12.7-14 1.98 10.16 9.83-2.44 13.93z"
      />
    </g>
  </svg>
);

export default SvgBBiconsEssHodnoceni;

